import { render, staticRenderFns } from "./CheckboxList.vue?vue&type=template&id=fead9310&scoped=true"
import script from "./CheckboxList.vue?vue&type=script&lang=js"
export * from "./CheckboxList.vue?vue&type=script&lang=js"
import style0 from "./CheckboxList.vue?vue&type=style&index=0&id=fead9310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fead9310",
  null
  
)

export default component.exports